!(function (q, _name) {
  ;(q[_name] =
    q[_name] ||
    function k() {
      ;(k.q = k.q || []).push(arguments)
    }),
    (q[_name].v = q[_name].v || 2),
    (q[_name].s = '1')
  !(function (q, k, F, H) {
    function m(F, H) {
      try {
        ;(m = q.localStorage),
          (F =
            JSON.parse(
              m[decodeURI(decodeURI('%67%25%36%35%74I%25%374%256%35%25%36%64'))](
                '_aQS02Mzg3RDEwMjU5NjBGOUQ0REY5Q0YwOTEtNTY0',
              ),
            ).lgk || []) &&
            (H = q[k].pubads()) &&
            F.forEach(function (q) {
              q && q[0] && H.setTargeting(q[0], q[1] || '')
            })
      } catch (N) {}
      var m
    }
    try {
      ;((H = q[k] = q[k] || {}).cmd = H.cmd || []),
        typeof H.pubads === F ? m() : typeof H.cmd.unshift === F ? H.cmd.unshift(m) : H.cmd.push(m)
    } catch (N) {}
  })(window, decodeURI(decodeURI('%67%25%36%66%256f%67l%2565%74%61%256%37')), 'function')
})(window, decodeURI(decodeURI('a%64%6d%256%39%72al')))
!(function (q, k, F, H) {
  ;(F = q.createElement(k)),
    (q = q.getElementsByTagName(k)[0]),
    (F.async = 1),
    (F.src = 'https://mowgoats.com/public/kehe9s_z53owv.index.js'),
    (H = 0) && H(F),
    q.parentNode.insertBefore(F, q)
})(document, 'script')
